import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Clock, Copy, Download, Check, Music } from "lucide-react";
import { toast } from "sonner";

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const SegmentItem = ({ item, index }) => {
  const [copied, setCopied] = useState(false);

  const copyText = () => {
    navigator.clipboard.writeText(item.text);
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 2000);
  };

  const exportSegment = () => {
    downloadBlob(new Blob([`[${item.timestamp}]\n${item.text}`], { type: "text/plain" }), `segment-${index + 1}.txt`);
    toast.success("Segment exported");
  };

  const downloadAudio = () => {
    if (item.id) {
      window.open(`${process.env.REACT_APP_BACKEND_URL}/api/transcriptions/${item.id}/audio`, "_blank");
      return;
    }
    toast.error("Audio not available for this segment");
  };

  return (
    <div
      className="bg-deepspace-bg border border-deepspace-border rounded-lg p-5 transition-all duration-300 hover:border-volt-blue/50 animate-in fade-in slide-in-from-bottom-2"
      data-testid={`transcript-item-${index}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-3 w-full">
        <div className="flex items-center gap-2 whitespace-nowrap">
          <Clock className="w-4 h-4 text-volt-blue" />
          <span className="font-jetbrains text-base text-volt-blue font-semibold">{item.timestamp}</span>
          <span className="text-sm text-[#A1A1AA]">Segment {index + 1}</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button size="sm" className="h-9 px-4 text-sm bg-volt-blue hover:bg-volt-blue/80 text-white transition-all" onClick={copyText} data-testid={`copy-segment-${index}`}>
            {copied ? <Check className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}
            {copied ? "Copied" : "Copy"}
          </Button>
          <Button size="sm" className="h-9 px-4 text-sm bg-[#10B981] hover:bg-[#10B981]/80 text-white transition-all" onClick={exportSegment} data-testid={`export-segment-${index}`}>
            <Download className="w-4 h-4 mr-2" />
            Export
          </Button>
          <Button size="sm" className="h-9 px-4 text-sm bg-[#8B5CF6] hover:bg-[#8B5CF6]/80 text-white transition-all" onClick={downloadAudio} data-testid={`download-audio-${index}`}>
            <Music className="w-4 h-4 mr-2" />
            Audio
          </Button>
        </div>
      </div>
      <p className="mt-3 text-[#EDEDED] text-sm leading-relaxed whitespace-pre-wrap" data-testid={`transcript-text-${index}`}>
        {item.text}
      </p>
    </div>
  );
};
